import { registerComponent } from '@gig/magic-common';
import KeycloakResetPasswordComponent from './keycloak-reset-password.vue.js';

var KeycloakResetPassword = registerComponent(KeycloakResetPasswordComponent);

export { KeycloakResetPassword };
